module.exports = __webpack_public_path__ + "img/toolsItem11.893c35ca.png";